import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

import { ref } from "vue";
import { useDisplay } from "vuetify";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { xs, sm, smAndUp } = useDisplay();

const informations = ref([
  {
    subtitle: "게임 난이도 설정",
    title: "더욱 재밌어진 콘텐츠",
    contents: [
      "1단계부터 5단계까지 난이도가 세분화 됐어요!",
      "이전보다 다양한 문제를 풀 수 있어요!",
    ],
    image: require("../../assets/saemitalk/saemi_info_1.png"),
  },
  {
    subtitle: "습관 형성 도우미",
    title: "건강한 습관 만들기 기능 추가",
    contents: [
      "생활 속 습관을 바로 잡아주는 새미 기능이 추가됐어요!",
      "총 3주간 습관을 형성할 수 있도록 도와줘요!",
      "습관 형성에 성공하면 스탬프를 찍어줘요!",
    ],
    image: require("../../assets/saemitalk/saemi_info_2.png"),
  },
  {
    subtitle: "수다왕 새미",
    title: "수다왕 새미 기능 추가",
    contents: [
      "중요한 인지기능인 '기억력'을 자극해요!",
      "최근에 있었던 일을 회상할 수 있게 도와줘요!",
      "대화를 많이 인증할수록 더 많은 보상이 주어져요!",
    ],
    image: require("../../assets/saemitalk/saemi_info_3.png"),
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "elevation-0",
    style: {"background-color":"transparent"}
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(informations.value, (information, index) => {
        return (_openBlock(), _createBlock(_component_v_row, {
          key: index,
          class: _normalizeClass(["reverse", { 'mx-16': _unref(smAndUp) }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "auto",
              class: _normalizeClass(["my-auto", { 'pb-0': _unref(xs) }]),
              "align-self": "end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: information.image,
                  class: _normalizeClass(["saemiIcons", { 'xs mx-auto pt-6 pb-0': _unref(xs), sm: _unref(sm) }])
                }, null, 8, ["src", "class"])
              ]),
              _: 2
            }, 1032, ["class"]),
            _createVNode(_component_v_col, {
              cols: "12",
              sm: "auto",
              "align-self": "end"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["bubble white", {
            'mx-6 mt-0 mb-4 px-0 py-4 ': _unref(xs),
            'mx-4 my-6 px-4 py-6': _unref(smAndUp),
          }])
                }, [
                  _createVNode(_component_v_card_subtitle, {
                    class: _normalizeClass(["pt-0", { 'text-body-2 justify-center': _unref(xs) }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(information.subtitle), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_v_card_title, {
                    class: _normalizeClass(["pt-0 font-weight-bold", {
              'text-subtitle-1 justify-center': _unref(xs),
              'text-h6 pb-6': _unref(smAndUp),
            }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(information.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(information.contents, (content, index) => {
                    return (_openBlock(), _createBlock(_component_v_card_text, {
                      class: _normalizeClass(["pt-0 pb-1 saemiDetails", { 'xs text-center': _unref(xs), 'text-body-1': _unref(smAndUp) }]),
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(content), 1)
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ], 2)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})